import styled from 'styled-components';

export const ConditionMenu = styled.div`
  padding: 8px;
  border-radius: 4px;
  max-width: 220px;
  max-height: 250px;
  overflow-y: auto;
  margin-left: 10px;
  //border: 1px solid #7888f5;
  background-color: #fff;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  border: 1px solid #ced4da;
  // min-width: 200px;
  gap: 8px;

  &.conditions {
    background: #fff;
    max-width: 200px;
    margin-left: 90px;

    span {
      background: #fff;
    }
  }
  span {
    padding: 4px 8px;
    cursor: pointer;
    display: block;
    color: #000;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    transition: all 0.25s ease-in-out;

    border-radius: 3px;
    /* border: 1px solid #fff; */
    /* background: #f3f3ff; */

    &:hover {
      background: #f1f3f5;
    }
  }

  .search {
    margin: 0;
    width: 100%;
    height: 30px;
    border-radius: 4px;
    background-color: #fff;
    color: #5c5d61;
    padding-left: 8px;
    gap: 0;
    border: 1px solid #ced4da;

    svg {
      width: 12px;
      height: 12px;
      path {
        fill: #adb5bd;
      }
    }

    input {
      color: #5c5d61;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: #000;
      background: transparent;
      padding: 4px 6px;
      border: none;
      height: auto;
      &::placeholder {
        color: #adb5bd;
      }
    }
  }
`;

export const AddActionWrapper = styled.div`
  margin-top: 8px;
  padding: 4.5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cdd4df;
  p {
    font-size: 12px;
    font-weight: 500;
  }

  .btn-group {
    display: flex;
    gap: 4px;

    .btn {
      background-color: #7888f5;
      border: none;

      &.active {
        background-color: #495bd1;
      }
    }
  }
`;

export const Header = styled.div`
  padding: 8px 12px;
`;

export const FilterWrapper = styled.div`
  overflow: hidden;
  width: auto;
  gap: 10px;
  padding: 0 16px;

  ${({ isChildrenGroup }) =>
    isChildrenGroup &&
    `
    max-width: 650px;
    width: 100%;
    border: none; 
    background-color: #F8F9FA!important;
    margin-left: 4px;
    box-shadow: none!important;
    overflow: hidden;
    border-radius: 8px;
    padding: 16px 16px 16px 0;
    

    .filter_card {
      border-top: none!important;
      border-bottom: none!important;
    }
`}

  /* box-shadow: 0px 171px 48px 0px rgba(0, 0, 0, 0),
0px 110px 44px 0px rgba(0, 0, 0, 0.01),
0px 62px 37px 0px rgba(0, 0, 0, 0.05), 0px 27px 27px 0px rgba(0, 0, 0, 0.09),
0px 7px 15px 0px rgba(0, 0, 0, 0.1); */

  .required {
    color: red;
  }

  .condition-box {
    display: flex;
    min-width: 420px;
    align-items: center;

    .filter-types {
      display: flex;
      width: 100%;
      flex-direction: column;
    }
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    margin-bottom: 16px;
    position: sticky;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid #f1f3f5;
    z-index: 99;

    .box {
      display: flex;
      align-items: center;
      gap: 5px;

      .label {
        margin: 0;
        font-size: 12px;
      }
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 5px;

      button {
        background-color: #f3f3ff;
        color: #5c5d61;
        border-color: #f3f3ff;
        display: flex;
        align-items: center;
      }
    }
  }

  .replace {
    border-top: 1px solid #cdd4df;
    padding: 10px 0;
    display: flex;
    align-items: center;
    gap: 23px;

    p {
      font-size: 10px;
      font-weight: 500;
      line-height: 12.13px;
      text-align: left;
      color: #5c5d61;
    }

    .select {
      cursor: pointer;
      padding: 4px 6px;
      border-radius: 6px;
      background: #f3f3ff;
      color: #5c5d61;
      font-size: 10px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: space-between;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .checkbox_line {
    display: flex;
    align-items: center;
    gap: 3px;
    // margin-bottom: -12px;

    .checkbox {
      margin: 0;
    }
    .line {
      width: 4px;
      height: 1px;
      border-top: 1px solid #cdd4df;
    }
  }

  .label {
    color: #2b313d;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 10px;

    margin-top: 8px;
    padding-top: 8px;
  }

  .post-condition {
    margin-top: 8px;
    widht: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .else {
      display: flex;
      align-items: center;
      margin-left: 20px;
      gap: 6px;

      p {
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #101113;
      }

      .form-element {
        min-width: 150px;

        .input-types {
          display: flex;
          align-items: center;
          gap: 2px;
          margin-bottom: -4px;

          form {
            display: flex;
            align-items: center;

            label {
              display: flex;
              align-items: center;
            }
          }

          input {
            width: 16px;

            &:disabled {
              opacity: 0.7;
            }
          }
        }

        label {
          color: #101113;
          font-size: 12px;
          font-weight: 500;
          display: block;
          margin-bottom: 4px;
          line-height: 15px;
        }

        .input {
          padding: 4px 6px;
          border-radius: 4px;
          background: #fff;
          color: #000;
          font-size: 10px;
          font-weight: 500;
          line-height: 12px;
          border: none;
          outline: none;
          width: 100%;
          border: 1px solid #ced4da;

          &:disabled {
            opacity: 0.7;
          }
        }
        .select {
          cursor: pointer;
          padding: 4px 6px;
          border-radius: 4px;
          background: #fff;
          color: #000;
          font-size: 10px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border: 1px solid #ced4da;
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }

  .filter_card {
    padding: 16px 0;
    border-top: 1px solid #f1f3f5;
    border-bottom: 1px solid #f1f3f5;
    display: flex;
    align-items: center;
    position: relative;
    overflow: auto;

    &.noBeforeLine {
      &::before {
        content: '';
        width: 0;
      }
    }

    &.noBorderTop {
      border-top: none;
    }

    &.noBorderBottom {
      border-bottom: none;
    }

    &.isChildren {
      margin-left: 16px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 1px;
        height: calc(100% - 60px);
        background-color: #e9ecef;
      }
    }

    &.isFilter {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 1px;
        height: calc(100% - 60px);
        background-color: #e9ecef;
      }
    }

    &::before {
      content: '';
      position: absolute;
      left: 35px;
      width: 1px;
      height: calc(100% - 60px);
      margin-top: 5px;
      background-color: #e9ecef;
    }

    &.isDisableBefore {
      &::before {
        display: none;
      }
    }

    &.noBorderRight {
      &::before {
        width: 0;
      }
    }

    .when {
      color: #aaa;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 19.6px */
      transform: rotateZ(-90deg);
    }

    .then {
      position: relative;
      margin-left: 32px !important;
      padding-left: 8px;

      &::before {
        content: '';
        position: absolute;
        left: -18px;
        width: 16px;
        height: 1px;
        background-color: #e9ecef;
        margin-top: 16px;
      }
    }

    .then,
    .else {
      display: flex;
      align-items: center;
      margin-left: 20px;
      gap: 6px;

      p {
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #000;
      }

      .form-element {
        min-width: 150px;
        .input-types {
          display: flex;
          align-items: center;
          gap: 2px;
          margin-bottom: -4px;

          form {
            display: flex;
            align-items: center;

            label {
              display: flex;
              align-items: center;
            }
          }

          input {
            width: 16px;

            &:disabled {
              opacity: 0.7;
            }
          }
        }

        label {
          color: #101113;
          font-size: 12px;
          font-weight: 600;
          display: block;
          margin-bottom: 4px;
          line-height: 14px;
        }
        .input {
          padding: 6px;
          /* border-radius: 6px;
          background: #f3f3ff; */
          /* color: #5c5d61; */
          font-size: 10px;
          font-weight: 500;
          line-height: 12px;
          border: none;
          outline: none;
          width: 100%;
          border-radius: 4px;
          border: 1px solid #ced4da;
          color: #000;
          background-color: #fff;
        }
        .select {
          cursor: pointer;
          padding: 4px 6px;
          /* border-radius: 6px;
          background: #f3f3ff; */
          color: #000;
          font-size: 10px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border-radius: 4px;
          border: 1px solid #ced4da;
          background-color: #fff;
          /* svg {
            width: 16px;
            height: 16px;
          } */
        }
      }
    }

    .filter_content {
      display: flex;
      flex-direction: column;
      gap: 14px;
      width: auto;
      position: relative;

      &.showFilterLine {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          background-color: #e9ecef;
          right: 0;
          width: 1px;
          height: calc(100% - 154px);
          margin-top: 17px;
        }
      }

      .group-wrapper {
        display: flex;

        .checkbox_line {
          display: flex;
          align-items: center;
          gap: 3px;
          margin-left: 15px;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            left: -15px;
            width: 15px;
            height: 1px;
            background: #cdd4df;
          }

          .checkbox {
            margin: 0;
          }

          .line {
            width: 4px;
            height: 1px;
            border-top: 1px solid #cdd4df;
          }
        }
      }
    }
  }

  .replace-btn {
    padding: 4px;
    border-radius: 6px;
    background: #f3f3ff;
    width: 24px;
    height: 24px;
  }
`;

export const FilterMenu = styled.div`
  padding: 0 12px 12px;
  border-radius: 6px;
  border: 1px solid #7888f5;
  background: #fff;
  max-height: 400px;
  overflow-y: auto;
  box-shadow:
    0px 171px 48px 0px rgba(0, 0, 0, 0),
    0px 110px 44px 0px rgba(0, 0, 0, 0.01),
    0px 62px 37px 0px rgba(0, 0, 0, 0.05),
    0px 27px 27px 0px rgba(0, 0, 0, 0.09),
    0px 7px 15px 0px rgba(0, 0, 0, 0.1);
  position: relative;

  overflow-x: visible;
  .separator {
    height: 1px;
    width: 100%;
    background-color: #e9ecef;
    margin: 4px 0;
  }

  .fixed {
    width: 100%;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 11;
    padding: 12px 0 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .label {
      color: #2b313d;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  .search {
    margin: 0;
    width: 100%;
    height: 20px;
    border-radius: 3px;
    background-color: #3d3bff33;
    color: #5c5d61;
    padding-left: 8px;
    gap: 0;

    svg {
      width: 12px;
      height: 12px;
      path {
        fill: #5c5d61;
      }
    }

    input {
      color: #5c5d61;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: #5c5d61;
      background: transparent;

      &::placeholder {
        color: #5c5d61;
      }
    }
  }

  .actions {
    width: 156px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 8px;
    gap: 5px;
    position: relative;

    span {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 9px 8px;
      border-radius: 6px;
      background: #f3f3ff;
      color: #5c5d61;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      overflow-x: visible;
    }
  }
`;

export const Body = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;

  .filter-btn {
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(61, 59, 255, 0.2);
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #5c5d61;
    svg {
      width: 16px;
      height: 16px;
      path {
        stroke: #5c5d61;
      }
    }
  }

  .form-element {
    .input-types {
      display: flex;
      align-items: center;
      gap: 2px;
      margin-bottom: -4px;

      form {
        display: flex;
        align-items: center;
      }

      input {
        width: 16px;
        &::disabled {
          opacity: 0.7;
        }
      }
    }

    label {
      color: #25262b;
      font-size: 12px;
      font-weight: 600;
      display: block;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
    }

    .input {
      padding: 4px 6px;
      border-radius: 4px;
      background: #fff;
      color: #000000;
      font-size: 12px;
      font-weight: 500;
      line-height: 12px;
      border: none;
      outline: none;
      width: 100%;
      border: 1px solid #ced4da;
      &:disabled {
        opacity: 0.7;
      }
    }
    .select {
      cursor: pointer;
      padding: 4px 6px;
      border-radius: 6px;
      color: #000;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      max-height: 36px;
      border-radius: 4px;
      border: 1px solid #ced4da;
      background-color: #fff;
      gap: 20px;
      /* svg {
        width: 16px;
        height: 16px;
      } */
    }
  }

  .skeleton-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #cdd4df;

    .skeleton {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #cdd4df;
      height: 32px;

      .skeleton-actions {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    border-top: 1px solid #cdd4df;

    .item {
      display: flex;
      height: 32px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #cdd4df;

      p {
        text-transform: capitalize;
      }

      .actions {
        display: flex;
        gap: 4px;
        align-items: center;

        button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 20px;
          cursor: pointer;
          border-radius: 6px;
          background: #f3f3ff;
          border: none;
          outline: none;

          svg {
            path {
              stroke: #2b313d;
            }
          }

          &.active {
            background-color: #3d3bff33 !important;
          }
        }
      }
    }
  }
`;

export const Tab = styled.div`
  cursor: pointer;
  padding: 8px;
  border: 1px solid ${({ isActive }) => (isActive ? '#CDE0FF' : '#cdd4df')};
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #2b313d;
  background-color: ${({ isActive }) => (isActive ? '#E7F0FF' : '#fff')};
  width: ${({ tableSize }) => `calc((100% - 93px)/${tableSize})`};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  span {
    color: #5c5d61;
    font-size: 12px;
    font-weight: 500;
    display: block;
    white-space: nowrap;
  }
`;

export const FilterColumnCardWrapperStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 24px;

  .drag-handle {
    display: flex;
    align-items: center;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 16px;
    height: 1px;
    background-color: #e9ecef;
  }

  &::after {
    content: '';
    position: absolute;
    right: -14px;
    width: 16px;
    height: 1px;
    margin-top: 6px;
    background-color: #e9ecef;
  }
`;

export const FilterColumnCardStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  width: 760px;
  border: 1px solid #cdd4df;
  padding: 5px;
  border-radius: 4px;
  position: relative;
  background-color: #fff;
  flex: 1;

  .checkbox_line {
    display: flex;
    align-items: center;
    gap: 3px;
    margin-bottom: -12px;

    .checkbox {
      margin: 0;
    }
    .line {
      width: 4px;
      height: 1px;
      border-top: 1px solid #e9ecef;
    }
  }
  .filter-columns {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;

    .replace-btn {
      padding: 4px;
      border-radius: 6px;
      background: #f3f3ff;
      width: 24px;
      height: 24px;
    }

    .filter-elements {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 4px;
      width: calc(100% - 28px);

      &.noFunction {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      .form-element {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 4px;

        .select {
          border: 1px solid transparent;

          /* svg {
            transition: all 0.25s ease-in-out;
            transform: rotate(0deg);
          } */
        }

        &.isOpenItems {
          .select {
            border: 1px solid #495bd1;

            /* svg {
              transform: rotate(90deg);
            } */
          }
        }

        .input-types {
          display: flex;
          align-items: center;
          gap: 2px;
          margin-bottom: -4px;

          form {
            display: flex;
            align-items: flex-end;

            label {
              display: flex;
              align-items: flex-end;
              height: 15px;
            }
          }

          input {
            width: 16px;
            height: 16px;

            &:disabled {
              opacity: 0.7;
            }
          }
        }

        label {
          color: #25262b;
          font-size: 12px;
          line-height: 16px;
          font-weight: 600;
          display: block;
          margin-bottom: 4px;
          display: flex;
          align-items: center;
        }

        .input {
          padding: 5px 6px;
          border-radius: 4px;
          background: #fff;
          color: #000;
          font-size: 12px;
          font-weight: 500;
          line-height: 12px;
          border: none;
          outline: none;
          width: 100%;
          border: 1px solid #ced4da;

          &:disabled {
            opacity: 0.7;
          }
        }
        .select {
          cursor: pointer;
          padding: 4px 6px;
          background: #fff;
          color: #000;
          font-size: 12px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 24px;
          border-radius: 4px;
          border: 1px solid #ced4da;
          /* svg {
            width: 16px;
            height: 16px;
          } */
        }
      }
    }
  }
`;

export const FilterBtnWithLine = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  .line {
    width: 24px;
    height: 1px;
    border-top: 1px solid #e9ecef;
  }
`;

export const Wrapper = styled.div`
  background: #fff;
  width: 100%;
  border: 1px solid #e9ecef;
  height: 100%;
  overflow: auto;

  .filter-btn {
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(61, 59, 255, 0.2);
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #5c5d61;
    svg {
      width: 16px;
      height: 16px;
      path {
        stroke: #5c5d61;
      }
    }
  }
`;
